import Paginate from 'vuejs-paginate'
import Header from './../../Headers/HeaderForAreLoggedIn/index.vue'
import Footer from './../../Footers/Footer/index.vue'
import ProgressHUD from './../../ProgressHUD/index.vue'
import BonusCarbonTradeItem from './BonusCarbonTradeItem/index.vue'
import GreenCertificatesTradeItem from './GreenCertificatesTradeItem/index.vue'
import Api from './../../../services/api'

export default {
  name: 'MarketBoard',
  components: {
    Header,
    Footer,
    ProgressHUD,
    Paginate,
    BonusCarbonTradeItem,
    GreenCertificatesTradeItem,
  },
  data() {
    return {
      projects: null,
      itemCount: 9,
      rowCount: 3,
      pageCount: null,
      validationMessage: '',
      search: {
        text: '',
        type: 'all',
        numberPage: 1,
        countPages: 1,
        limit: 9,
      },
    }
  },
  watch: {
    $route() {
      this.search.text = this.$route.query.text || ''
      this.search.type = this.$route.query.type || 'all'
      this.search.numberPage = +this.$route.query.page || 1

      this.refreshDisplayProjects()
    },
  },
  methods: {
    changeTypeFilter(type) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          type: type,
        }),
      })
    },
    changePage(numberPage) {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          page: numberPage,
        }),
      })
    },
    searchClick() {
      this.$router.push({
        query: Object.assign({}, this.$route.query, {
          text: this.search.text,
        }),
      })
    },
    async refreshDisplayProjects() {
      try {
        this.$refs.progress.show()
        var response = await Api.getTradeOfCO2(this.search)
        this.projects = response.data.results
        this.search.countPages = response.data.pagination.countPages

        jQuery(document).ready(function($) {
          $('[data-toggle="tooltip"]').tooltip()
        })
      } catch (error) {
        console.error(error)
        alert(error.message)
      } finally {
        this.$refs.progress.hide()
      }
    },
  },
  async created() {
    this.search.text = this.$route.query.text || ''
    this.search.type = this.$route.query.type || 'all'
    this.search.numberPage = +this.$route.query.page || 1

    this.$nextTick().then(() => this.refreshDisplayProjects())
  },
}



// WEBPACK FOOTER //
// ./src/components/TradeOfCO2/TradeBoard/MarketBoard.component.js